<template>
  <div>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{ $t("general") }}</v-tab>
      <v-tab key="Reg Fields">{{
        $tc("entities.regTypeFields.title", 2)
      }}</v-tab>
      <v-tab key="Triggers" v-if="triggers">{{
        $tc("entities.regType.props.trigger.title", 2)
      }}</v-tab>

      <v-tabs-slider></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-container>
            <v-form v-model="valid" ref="form">
              <v-text-field
                :label="$t('entities.regType.props.code')"
                :rules="$isRequiredRule"
                v-model="value.code"
                clearable
              ></v-text-field>
              <v-text-field
                :label="$t('entities.regType.props.description')"
                :rules="$isRequiredRule"
                v-model="value.description"
                clearable
              ></v-text-field>
               <v-checkbox v-model="value.allowRetroactive" :label="$t('entities.regType.props.allowRetroactive')"/>
                 <v-text-field
                :label="$t('entities.regType.props.retroactiveLimitDays')"
                v-model="value.retroactiveLimitDays"
                type="number"
                clearable
              ></v-text-field>
              <color-dialog
                v-model="value.color"
                :label="$t('entities.regType.props.color')"
              ></color-dialog>
              <v-checkbox v-model="value.continuous" :label="$t('entities.regType.props.continuous')"/>
              <v-select
              v-if="value.continuous"
                v-model="value.keepFieldIds"
                :items="value.regTypeFields"
                :label="$t('entities.regType.props.keepFieldIds')"
                item-text="label"
                item-value="id"
                multiple
              ></v-select>
              <v-select
                v-model="value.timeType"
                :items="$timeTypes"
                :label="$t('entities.regType.props.timeType')"
                item-text="value"
                item-value="key"
              ></v-select>
              <v-select
                :rules="$isRequiredRule"
                v-model="value.environmentId"
                :items="environments"
                :label="$t('entities.regType.props.environmentId')"
                item-text="description"
                item-value="id"
                clearable
              ></v-select>
              <v-select
                v-model="value.jobStatusId"
                :items="environment.jobStatus"
                :label="$t('entities.regType.props.jobStatusId')"
                item-text="status"
                item-value="id"
                clearable
              ></v-select>
              <v-select
                v-model="value.jobStageStatusId"
                :items="environment.jobStageStatus"
                :label="$t('entities.regType.props.jobStageStatusId')"
                item-text="status"
                item-value="id"
                clearable
              ></v-select>
              <v-checkbox
                v-model="value.stageRequired"
                :label="$t('entities.regType.props.stageRequired')"
              />

              <auto-complete-entity
                ref="report"
                v-model="value.reportId"
                entityApi="report"
                :itemPreSelected="selectedReport"
                fieldApi="description"
                itemText="description"
                itemValue="id"
                :label="$t('entities.regType.props.reportId')"
                prependIcon="mdi-find-replace"
              />
              <auto-complete-entity
                ref="printer"
                v-model="value.printerId"
                entityApi="printer"
                :itemPreSelected="selectedPrinter"
                fieldApi="description"
                itemText="description"
                itemValue="id"
                :label="$t('entities.regType.props.printerId')"
                prependIcon="mdi-find-replace"
              />
            </v-form>
          </v-container>
        </v-tab-item>
        <v-tab-item key="RegFields">
          <v-container>
            <regTypeFieldTabItem v-model="value" />
          </v-container>
        </v-tab-item>
        <v-tab-item key="Triggers" v-if="triggers">
          <v-container v-if="value.trigger">
              <v-text-field
              :label="$t('entities.regType.props.trigger.props.confirm')"
              v-model="value.trigger.confirm"
            ></v-text-field>
            <v-text-field
              :label="$t('entities.regType.props.trigger.props.beforeSend')"
              v-model="value.trigger.beforeSend"
            ></v-text-field>
            <v-text-field
              :label="$t('entities.regType.props.trigger.props.afterSend')"
              v-model="value.trigger.afterSend"
            ></v-text-field>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import reportService from "@/services/reportService";
import printerService from "@/services/printerService";
import regTypeFieldTabItem from "@/components/forms/regTypes/regTypeFieldTabItem";
import authService from "@/services/authService.js";
export default {
  props: {
    value: {
      default() {
        return {
          regTypeFields: [],
        };
      },
    },
    environments: {
      default() {
        return [];
      },
    },
  },
  components: { regTypeFieldTabItem },
  data() {
    return {
      openColor: false,
      color: {},
      tab: null,
      valid: true,
      selectedReport: null,
      selectedPrinter: null,
      triggers: false,
    };
  },
  watch: {
    async value() {
      if (!this.value.trigger) this.value.trigger = {};
      this.selectedReport = null;
      this.selectedPrinter = null;
      this.color.hex = this.value.color;
      this.$refs.form.resetValidation();
      await this.getReport();
      await this.getPrinter();
    },
    color() {
      this.value.color = this.color.hex;
    },
  },
  computed: {
    environment() {
      let environment = this.environments.filter(
        (e) => e.id == this.value.environmentId
      )[0];
      if (environment == null)
        return {
          description: "",
          jobStatus: [],
          jobStageStatus: [],
          calendarProds: [],
          calendarExcs: [],
        };
      return this.environments.filter(
        (e) => e.id == this.value.environmentId
      )[0];
    },
  },
  methods: {
    async getReport() {
      if (!this.value.reportId) {
        this.selectedReport = null;
        return;
      }
      let res = await reportService.getById(this.value.reportId);
      if (res.success) this.selectedReport = res.data;
    },
    async getPrinter() {
      if (!this.value.printerId) {
        this.selectedPrinter = null;
        return;
      }
      let res = await printerService.getById(this.value.printerId);
      if (res.success) this.selectedPrinter = res.data;
    },
    isValid() {
      return this.$refs.form.validate();
    },
    clickColor() {
      this.openColor = !this.openColor;
    },
  },
  async mounted() {
    if(!this.value.keepFieldIds)this.value.keepFieldIds = []
    let params = await authService.getUserParams();
    this.triggers = params.triggers;
    await this.getReport();
    await this.getPrinter();
  },
  created() {
    if (!this.value.trigger) this.value.trigger = {};
  },
};
</script>